import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import OperatorImpcSelectionCriteriaContainer
  from '../../../common/selection-criteria/operator-impc/container/OperatorImpcSelectionCriteriaContainer';
import ListTable from '../../../common/tables/ListTable';
import TableDefinitions from '../../../common/TableDefinitions';
import { getLeftCheckedMailProcessingCenters } from '../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getColumns, getData, getIsLoading } from '../redux/selectors/ImpcDetailsSelectors';
import { tableLoadData } from '../../../common/tables/actions/ListTableActions';
import DownloadTypes from '../../../common/tables/excel/DownloadTypes';

class ImpcDetailsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
    };
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });
    this.props.tableLoadData(
      { tableId: 'IMPC_DETAILS_PAGE' },
      this.props.appContext.appContext,
      { impcCodes: this.props.checkedMailProcessingCenters },
    );
  };

  render() {
    const { isLoading, data, columns } = this.props;
    const { showResult } = this.state;

    return (
      <div>
        <OperatorImpcSelectionCriteriaContainer
          open={data.length === 0}
          title="IMPC DETAILS"
          onApply={this.onCriteriaApply}
        />
        <div className="general-content-container">
          {(showResult || data.length > 0) && (
            <div className="full-width">
              <div className="list-table-container" style={{ paddingBottom: '20px', minHeight: '740px' }}>
                <ListTable
                  listId={TableDefinitions.IMPC_DETAILS_PAGE.id}
                  loading={isLoading}
                  columns={columns}
                  data={data}
                  keyField="id"
                  downloadType={DownloadTypes.EXCEL}
                  selectCheckbox
                  pagination
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

ImpcDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.string),
  isLoading: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    isLoading: getIsLoading(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ImpcDetailsContainer);
